export default __webpack_public_path__ + "static/properties/20260316-200400.316/launcher_zh_TW.properties";